// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"9874a162","718":"4a549e12","787":"d02c87a3"}[chunkId] + ".chunk.js";
};